import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowRight,
  faCheck,
  faComments,
  faGraduationCap,
  faHandshake,
  faRocket,
} from "@fortawesome/free-solid-svg-icons";
import avatar from "./images/my_imgs/avatar.png";
import graduationImg from "./images/my_imgs/graduation_img.png";

const facebookUrl = "https://www.facebook.com/vuminhduc30/";

const painPoints = [
  {
    title: "Phân vân giữa nhiều ngành nghề",
    text:
      "Software, AI, Data, Product hay Cybersecurity đều có điểm hấp dẫn, nhưng bạn chưa biết hướng nào hợp với profile và mục tiêu ở Úc.",
  },
  {
    title: "Cần cải thiện hồ sơ",
    text:
      "CV, LinkedIn, project và câu chuyện cá nhân cần được sắp xếp lại để người tuyển dụng hiểu rõ bạn có gì.",
  },
  {
    title: "Kỹ năng xin việc",
    text:
      "Bạn cần biết cách đọc job description, chọn job, tailor CV, networking, chuẩn bị interview và kể câu chuyện của mình.",
  },
];

const consultationExamples = [
  "CV của em có vấn đề gì?",
  "Tại sao em apply nhiều nhưng không có interview?",
  "Em nên làm project gì để cho vào CV?",
  "Profile hiện tại có đủ để apply internship chưa?",
  "Sắp có interview thì nên chuẩn bị gì?",
  "Năm 2-3 nên chuẩn bị gì để sau này dễ tìm job hơn?",
  "Nên tập trung LinkedIn, networking hay apply trực tiếp?",
];

const serviceOptions = [
  {
    icon: faComments,
    title: "30 phút Career Consultation",
    price: "$25 AUD",
    text:
      "Phù hợp nếu bạn đang có một vấn đề cụ thể và muốn hỏi thẳng để biết mình nên ưu tiên gì tiếp theo.",
    items: ["Xem nhanh CV / LinkedIn", "Gỡ vấn đề job hunting", "Gợi ý bước tiếp theo"],
    cta: "Đặt lịch 30 phút",
    inquiryType: "consultation",
  },
  {
    icon: faRocket,
    title: "Job Hunter A-Z",
    price: "3 sessions 1:1",
    text:
      "Dành cho bạn muốn đi bài bản từ CV, cách tìm và apply job, đến interview.",
    items: ["CV & profile", "Apply strategy", "Mock interview + feedback"],
    cta: "Hỏi thông tin A-Z",
    inquiryType: "jobHunter",
    featured: true,
  },
  {
    icon: faHandshake,
    title: "Long-term Mentoring",
    price: "Trao đổi theo mục tiêu",
    text:
      "Dành cho bạn muốn đồng hành lâu hơn về định hướng, skill, project, experience, CV và internship.",
    items: ["Career direction", "Project plan", "Hướng dẫn làm project cá nhân", "Chuẩn bị internship / graduate job"],
    cta: "Trao đổi mentoring",
    inquiryType: "mentoring",
  },
];

const jobHunterSessions = [
  {
    title: "Session 1 - CV & Profile",
    text:
      "Đi qua education, work experience, project, technical skills, CV, LinkedIn và role bạn muốn apply.",
    outcomes: ["Biết CV đang thiếu gì", "Biết experience nào nên giữ / bỏ", "Position đúng loại job"],
  },
  {
    title: "Session 2 - Cách tìm và apply job",
    text:
      "Tập trung vào cách đọc job description, chọn job nên apply, tailor CV, referral và networking.",
    outcomes: ["Biết job nào đáng apply", "Có strategy thay vì apply đại trà", "Có việc cụ thể để làm giữa sessions"],
  },
  {
    title: "Session 3 - Interview",
    text:
      "Chuẩn bị tell me about yourself, behavioural questions, STAR, project questions và mock interview.",
    outcomes: ["Có câu chuyện STAR", "Biết xử lý câu hỏi mới", "Nhận feedback sau mock interview"],
  },
];

const parentPoints = [
  "Sau này muốn đi hướng nào",
  "Skill nào thực sự cần",
  "Project nào đáng làm",
  "Khi nào nên tìm internship",
  "Làm sao để tích luỹ experience",
  "Khi nào nên bắt đầu CV và LinkedIn",
];

const jobHunterResults = [
  "2 bản CV hoàn chỉnh cho các nhóm job khác nhau",
  "CV được sửa dựa trên chính experience của bạn",
  "Cách tìm và chọn job để apply",
  "Một số câu chuyện STAR cho behavioural interview",
  "Mock interview + feedback",
  "Một plan rõ ràng để tiếp tục job hunting",
];

const mentoringDetails = [
  "Định hướng career: Software, AI, Data hoặc hướng khác phù hợp hơn",
  "Roadmap skill theo mục tiêu thật của bạn",
  "Hướng dẫn làm project cá nhân để đưa vào CV",
  "Cách tìm experience, internship hoặc cơ hội ngoài job board",
  "Chuẩn bị CV, LinkedIn, networking và interview theo từng giai đoạn",
];

const ServicePage = () => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = "Tư vấn tìm việc ở Úc | Dustin Vu";

    return () => {
      document.title = previousTitle;
    };
  }, []);

  const renderServiceDetails = (type) => {
    if (type === "consultation") {
      return (
        <details className="service-card-details">
          <summary>Buổi 30 phút dành cho ai?</summary>
          <p>
            Nếu bạn có một câu hỏi cụ thể, đây là cách nhanh nhất để gỡ. Mang
            theo CV, LinkedIn hoặc những job bạn đang muốn apply.
          </p>
          <ul>
            {consultationExamples.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </details>
      );
    }

    if (type === "jobHunter") {
      return (
        <details className="service-card-details">
          <summary>Xem 3 sessions trong Job Hunter A-Z</summary>
          <div className="service-detail-stack">
            {jobHunterSessions.map((session, index) => (
              <div key={session.title}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <h4>{session.title}</h4>
                <p>{session.text}</p>
                <ul>
                  {session.outcomes.map((outcome) => (
                    <li key={outcome}>{outcome}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
          <h4>Sau 3 sessions bạn sẽ có gì?</h4>
          <ul>
            {jobHunterResults.map((item) => (
              <li key={item}>{item}</li>
            ))}
          </ul>
        </details>
      );
    }

    return (
      <details className="service-card-details">
        <summary>Mentoring có thể đi qua những gì?</summary>
        <p>
          Không phải ai cũng đang sẵn sàng đi tìm việc ngay. Mình sẽ xem tình
          trạng hiện tại trước rồi mới quyết định nên đi theo hướng nào.
        </p>
        <ul>
          {mentoringDetails.map((item) => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      </details>
    );
  };

  return (
    <main className="service-page">
      <section className="service-hero">
        <nav className="service-topbar" aria-label="Điều hướng trang dịch vụ">
          <a className="service-brand" href="/">
            Dustin Vu
          </a>
          <div className="service-topbar-links">
            <a href="#services">Dịch vụ</a>
            <a
              className="service-topbar-cta"
              href={facebookUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              Đặt lịch
            </a>
          </div>
        </nav>

        <div className="service-hero-inner">
          <div className="service-hero-copy-block">
            <p className="service-eyebrow">Tư vấn career cho sinh viên Việt Nam tại Úc</p>
            <h1>Muốn tìm việc ở Úc nhưng không biết bắt đầu từ đâu?</h1>
            <p className="service-hero-copy">
              Mình hỗ trợ các bạn sinh viên và fresh graduate cải thiện CV, cách
              apply job và interview tại Úc. Nếu bạn đang apply mãi chưa có
              interview, không biết CV có vấn đề gì, hoặc không biết bước tiếp
              theo nên làm gì, bạn có thể bắt đầu bằng một buổi 30 phút.
            </p>
            <div className="service-hero-actions">
              <a
                className="service-cta service-cta-primary"
                href={facebookUrl}
                target="_blank"
                rel="noopener noreferrer"
              >
                Tư vấn hỏi đáp 30 phút
                <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
              </a>
              <a className="service-cta service-cta-secondary" href="#services">
                Xem mình có thể giúp gì
              </a>
            </div>

          </div>

          <figure className="service-hero-photo">
            <img src={avatar} alt="Dustin Vu" />
          </figure>
        </div>
      </section>

      <section className="service-section" id="story">
        <div className="service-section-inner">
          <div className="service-section-header">
            <p className="service-kicker">Vấn đề thường gặp</p>
            <h2>Tìm job full-time đúng ngành đầu tiên ở Úc không chỉ là gửi CV.</h2>
            <p>
              Apply job ở Úc là một nghệ thuật mà ai từng trải qua mới hiểu hết:
              CV, cover letter, visa, LinkedIn, project, văn hoá small talk trong
              interview, và cách trả lời câu hỏi đều ảnh hưởng rất nhiều đến khả
              năng có offer. Mục tiêu của mình là giúp bạn nhìn rõ tình trạng hiện
              tại, sửa những điểm đang cản bạn, và tối ưu cách chuẩn bị để tăng
              cơ hội xin được job đầu tiên đúng ngành.
            </p>
          </div>

          <div className="service-story-grid">
            {painPoints.map((point, index) => (
              <article className="service-story-step" key={point.title}>
                <span className="service-step-number">{index + 1}</span>
                <h3>{point.title}</h3>
                <p>{point.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="service-section service-offer-band" id="services">
        <div className="service-section-inner">
          <div className="service-section-header service-section-header-wide">
            <p className="service-kicker">Mình có thể giúp bạn gì?</p>
            <h2>Bắt đầu nhỏ bằng một buổi tư vấn, hoặc đi bài bản hơn nếu bạn cần.</h2>
            <p>
              Tuỳ vào tình trạng hiện tại, bạn có thể chọn một buổi hỏi nhanh,
              một chương trình bài bản hơn, hoặc mentoring dài hạn.
            </p>
          </div>

          <div className="service-offer-grid">
            {serviceOptions.map((option) => (
              <article
                className={`service-offer-card ${option.featured ? "featured" : ""}`}
                key={option.title}
              >
                <FontAwesomeIcon icon={option.icon} className="service-card-icon" aria-hidden="true" />
                <p className="service-card-price">{option.price}</p>
                <h3>{option.title}</h3>
                <p>{option.text}</p>
                <ul className="service-card-list">
                  {option.items.map((item) => (
                    <li key={item}>
                      <FontAwesomeIcon icon={faCheck} aria-hidden="true" />
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
                <a
                  className="service-card-link"
                  href={facebookUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {option.cta}
                  <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
                </a>
                {renderServiceDetails(option.inquiryType)}
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="service-section service-offer-band" id="parents">
        <div className="service-section-inner service-parent-grid">
          <div>
            <p className="service-kicker">Nếu bạn là phụ huynh</p>
            <h2>Chuẩn bị sớm thường tốt hơn đợi đến năm cuối mới lo.</h2>
            <p>
              Nhiều phụ huynh hỏi mình: con đang học năm 1-2 rồi, bây giờ nên
              chuẩn bị gì để sau này ra trường dễ tìm việc hơn? Theo mình, đây
              là thời điểm rất tốt để bắt đầu, không phải để học thêm thật nhiều
              một cách mơ hồ, mà để biết cái gì thật sự nên ưu tiên.
            </p>
          </div>
          <ul className="service-check-list">
            {parentPoints.map((item) => (
              <li key={item}>
                <FontAwesomeIcon icon={faGraduationCap} aria-hidden="true" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="service-section">
        <div className="service-section-inner service-about-block">
          <div className="service-about-copy">
            <p className="service-kicker">Một chút về mình</p>
            <h2>Mình chia sẻ từ kinh nghiệm thực tế tại Úc.</h2>
            <p>
              Hiện tại mình đang làm Software Engineer tại Melbourne. Trước đây
              mình từng làm Research Engineer tại CSIRO Data61 và Teaching
              Associate tại Monash University. Những gì mình chia sẻ sẽ thiên về
              kinh nghiệm thực tế trong Software, IT và Tech.
            </p>
            <a
              className="service-inline-link"
              href="/"
              aria-label="Xem trang cá nhân của Dustin Vu"
            >
              Xem trang cá nhân
              <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
            </a>
          </div>
          <figure className="service-about-photo">
            <img src={graduationImg} alt="Dustin Vu trong lễ tốt nghiệp" />
          </figure>
        </div>
      </section>

      <section className="service-final-cta" id="contact">
        <p className="service-eyebrow">Bắt đầu đơn giản</p>
        <h2>Nhắn mình trên Facebook</h2>
        <p>
          Gửi mình vài dòng về tình trạng hiện tại của bạn, CV hoặc role bạn
          đang muốn apply, rồi mình sẽ phản hồi trên Facebook.
        </p>
        <a
          className="service-cta service-cta-primary"
          href={facebookUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          <FontAwesomeIcon icon={faComments} aria-hidden="true" />
          Facebook
        </a>
      </section>
    </main>
  );
};

export default ServicePage;
